import { LayoutDashboard, Newspaper, Settings } from "lucide-react";
import React from "react";

interface MenuItem {
  id?: string;
  label: string;
  link?: string;
  icon?: React.ReactElement;
  isTitle?: boolean;
}

const menuData: MenuItem[] = [
  {
    label: "menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboard",
    link: "/dashboard",
    icon: <LayoutDashboard />,
  },
  {
    id: "saleOrders",
    label: "Pedidos",
    link: "/sale-orders",
    icon: <Newspaper />,
  },
  {
    id: "settings",
    label: "Configurações",
    link: "/settings",
    icon: <Settings />,
  },
];

export { menuData };
